import { createContext, useContext } from 'react';

const ModalFormContext = createContext(false);

export const ModalFormProvider = ModalFormContext.Provider;

/** True when rendered inside a Modal with default form layout. */
export function useInModalForm(): boolean {
  return useContext(ModalFormContext);
}
